/** @format */

export namespace NsEmployeeWebExp {
  export interface IEnv {
    empExp: string;
    tms: string;
    floorplan: string;
    empExpUI: string;
    navLinks: INavLinks;
    platform: "ets" | "stratus";
    empExpStatic: string;
    parkingFloorPlan: string;
    floorPlanSvc: string;
  }

  export interface INavLinks {
    meetingRooms: string;
    vaccinationUpload: string;
  }

  export interface IUserInfo {
    buid: string;
    empGuid: string;
  }
}
